import { createVanIconComponent } from "./van"

const Points = createVanIconComponent("points")
export default Points
